/**
 * For data fetched again as what's shown changes (or on coming back to a page
 * kept alive): a request answered after another has been sent settles with no
 * response, so that it can't replace the later one's (or what's been done
 * since, as more of a list loaded).
 */
export default class LatestRequest {
  private latest?: Promise<unknown>;

  /** Its response, unless another request has been sent since */
  async send<Response>(
    request: Promise<Response>
  ): Promise<Response | undefined> {
    this.latest = request;
    try {
      const response = await request;
      return request === this.latest ? response : undefined;
    } catch (error) {
      if (request === this.latest) {
        throw error;
      }
      return undefined;
    }
  }
}
